import keyMirror from 'keymirror';
import { withLanguageLocale } from '../../../services/Helper';
import { TUTORING_MARKETING_PAGE_URL } from '../../../services/Constants';

export const lessonOverviewActionTypes = keyMirror({
	GET_LESSON_OVERVIEW_REQUEST: null,
	GET_LESSON_OVERVIEW_SUCCESS: null,
	GET_LESSON_OVERVIEW_ERROR: null,
	GET_RECOMMENDED_LESSONS_REQUEST: null,
	GET_RECOMMENDED_LESSONS_SUCCESS: null,
	GET_RECOMMENDED_LESSONS_ERROR: null,
	CHANGE_LESSON_OVERVIEW_FILTERS: null,
	GET_MY_SCHEDULED_LESSONS_REQUEST: null,
	GET_MY_SCHEDULED_LESSONS_SUCCESS: null,
	GET_MY_SCHEDULED_LESSONS_ERROR: null,
});

export const OVERVIEW_VIDEO_ID = '1088332464';

export const getLessonsOverviewTabs = (t) => [
	{
		title: t('tutoring.lessons_overview.tabs.overview'),
		value: '',
		index: 0,
		link: withLanguageLocale('/lessons'),
	},
	{
		title: t('tutoring.lessons_overview.tabs.my_lessons'),
		value: 'my-lessons',
		index: 1,
		link: withLanguageLocale('/lessons/my-lessons'),
		notificationPriorityType: true,
	},
];

export const getFaqOverviewPage = (t) => [
	{
		title: t('tutoring.lessons_overview.faq.section_1.title'),
		description: t('tutoring.lessons_overview.faq.section_1.description'),
	},
	{
		title: t('tutoring.lessons_overview.faq.section_2.title'),
		description: t('tutoring.lessons_overview.faq.section_2.description'),
	},
	{
		title: t('tutoring.lessons_overview.faq.section_3.title'),
		description: t('tutoring.lessons_overview.faq.section_3.description'),
		link_1: {
			text: t('tutoring.lessons_overview.faq.section_3.link_1'),
			url: TUTORING_MARKETING_PAGE_URL,
			linkOutside: true,
		},
	},
];
